<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required"> Status </label>
          <div class="p-col ">
            <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
              placeholder="Choose" v-model="obj_data.status" :options="listCarSell" :reduce="item => item.id"
              label="name" :disabled="obj_data.status ==='SOLD_OUT_SELL' && mode === 'edit'">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="status">
          </div>
        </div>


        <div class="p-card-field" v-if="mode == 'edit' && obj_data.status == 2 && detail_visit">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Sale order </label>
          <div class="p-col link-detail-visit-a">
            <router-link :to="`/admin/list-visit_list/edit/${detail_visit}`">
              <InputText id="code" type="text" class="link-detail-visit-a disabled-input" v-model="code_sold_out"
                placeholder="Input" readonly />
            </router-link>
          </div>
        </div>



        <div class="p-card-field" v-if="mode == 'add'">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Car code </label>
          <div class="p-col">
            <InputText id="code" type="text" class="" v-model="obj_data.code" placeholder="Input" />
          </div>
        </div>
        <div class="p-card-field" v-if="mode == 'edit'">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Car code </label>
          <div class="p-col">
            <InputText id="code" type="text" class="" v-model="obj_data.code" placeholder="Input" :disabled="true" />
          </div>
        </div>
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Car name </label>
          <div class="p-col">
            <InputText id="carname" class="p-inputtext p-col-width pac-target-input" placeholder="Input"
              v-model="obj_data.name" />
          </div>
        </div>
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right">Plate number </label>
          <div class="p-col">
            <InputText id="plate_number" class="p-inputtext p-col-width pac-target-input" placeholder="AO-31-BE"
              v-model="obj_data.plate_number" />
          </div>
        </div>
        <div class="fontweightbold p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Price before discount</label>
          <div class="p-col">
            <div class="p-inputgroup class-left1111">
              <!-- <InputText id="price_per_unit" v-model="obj_data.price_per_unit" type="number" min="0"  placeholder="00.00"/> -->
              <InputNumber v-model="obj_data.price_before" :min="0" id="price_before" :minFractionDigits="2" :maxFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon asdasdfasf">$</span>
            </div>
          </div>
        </div>
        <div class="fontweightbold p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Price after discount</label>
          <div class="p-col">
            <div class="p-inputgroup class-left1111">
              <!-- <InputText id="price_per_unit" v-model="obj_data.price_per_unit" type="number" min="0"  placeholder="00.00"/> -->
              <InputNumber v-model="obj_data.price" :min="0" id="price" :minFractionDigits="2" :maxFractionDigits="2"
                placeholder="00.00" />
              <span class="p-inputgroup-addon asdasdfasf">$</span>
            </div>
          </div>
        </div>

        <div class="p-card-field ">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required ">Showroom </label>
          <div class="p-col">
            <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
              placeholder="Choose" v-model="obj_data.showroom_id" :options="listShowRoom" :reduce="item => item.id"
              label="name">
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="showroom">
          </div>
        </div>

        <div class="p-card-field ">
          <label class="indam-car-for-sell p-col-fixed txt-right css-tieu-de-big">CAR INFOMATION</label>
          <div class="p-col">
          </div>
        </div>

        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Make </label>
            <div class="p-col">
              <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
                placeholder="Choose" v-model="obj_data.make_vehicle_category_id" :options="listVehicleCategory"
                :reduce="item => item.id" label="name">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="make">
            </div>
          </div>
          <div class="box_lat_log ">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Model </label>
            <div class="p-col">
              <InputText id="model" v-model="obj_data.model" placeholder="Input" />
            </div>
          </div>
        </div>
        <div class="p-card-field style_box_lat_log">


          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Build </label>
            <div class="p-col">

              <Calendar1 placeholder="YYYY" style="width: 100%" v-model="obj_data.build" view="year" dateFormat="yy"
                appendTo="self" :showIcon="true" />



              <input class="input_tmp_validator" id="build" />
            </div>
          </div>

          <div class="box_lat_log color-suggestion-component">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required color-label">Colour </label>
            <div class="p-col color-input-wrapper">
              <InputText id="color_id" v-model="colorInput" placeholder="Input" @input="filterColors" />
              <ul v-if="filteredColors.length" class="suggestion-list">
                <li v-for="color in filteredColors" :key="color.id" @click="selectColor(color)">
                  {{ color.name }}
                </li>
              </ul>
            </div>
          </div>


        </div>
        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">New/ Used </label>
            <div class="p-col">
              <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
                placeholder="Choose" v-model="obj_data.type" :options="list_type" :reduce="item => item.id"
                label="name">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="new_used">
            </div>
          </div>
          <div class="box_lat_log width-odo111">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Odometer </label>
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.odometer" :min="0" id="odometer" placeholder="0" :minFractionDigits="0"
                :maxFractionDigits="0" />
              
              <span class="p-inputgroup-addon"> km</span>
            </div>
          </div>
        </div>
        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Fuel type </label>
            <div class="p-col">
              <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
                placeholder="Choose" v-model="obj_data.fuel_type_id" :options="listCarCommon_type1"
                :reduce="item => item.id" label="name">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="fuel_type_id">
            </div>
          </div>
          <div class="box_lat_log width-odo111">
            <label class="indam-car-for-sell p-col-fixed txt-right">Battery capacity </label>
            <div class="p-inputgroup">
              <InputNumber v-model="obj_data.battery_capacity" :min="0" id="battery_capacity" placeholder="0"
                :disabled="this.CarElectric.id !== this.obj_data.fuel_type_id" />
              <span class="p-inputgroup-addon">kWh</span>
            </div>
          </div>
        </div>





        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Transmission </label>
            <div class="p-col">
              <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
                placeholder="Choose" v-model="obj_data.transmission_id" :options="listCarCommon_type2"
                :reduce="item => item.id" label="name">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="transmission_id">
            </div>
          </div>

        </div>
        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Finace </label>
            <div class="p-col">
              <v-select :key="key_type_id" :clearable="false" title="Property" class="" @search="SearchPropertyType"
                placeholder="Choose" v-model="obj_data.finance_id" :options="listCarCommon_type3"
                :reduce="item => item.id" label="name">
                <span slot="no-options" @click="$refs.select.open = false">
                  Empty data
                </span>
              </v-select>
              <input class="input_tmp_validator" id="finance_id">
            </div>
          </div>
        </div>
        <div class="p-card-field style_box_lat_log">
          <div class="box_lat_log">
            <label class="indam-car-for-sell p-col-fixed txt-right">Rego validation </label>
            <div class="p-col">


              <Calendar1 style="width: 100%" v-model="obj_data.rego_validation" view="month" dateFormat="mm/yy"
                appendTo="self" :showIcon="true" placeholder="MM/YYYY" />

            </div>
            <input class="input_tmp_validator"  />


          </div>
        </div>


      </div>
      <div class="col-6">
        <div class="p-card-field mt-2">
          <label class="indam-car-for-sell p-col-fixed txt-right">Alt</label>
          <div class="p-col">
            <InputText id="alt" class="p-inputtext p-col-width pac-target-input ml-0"
              placeholder="Input (max 255 charactors)" v-model="obj_data.alt" maxlength="255" />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Cover image </label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Recommended: 800x450px</div>
            <div class="cus-text opacity-text-file">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFileCover" />
            <input class="input_tmp_validator" id="list_file_cover">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file_cover" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClearCover(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="col-4">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Car image </label>
          <div class="p-col">
            <div class="cus-text opacity-text-file">Recommended: 800x450px</div>
            <div class="cus-text opacity-text-file">Accepted: JPG, JPEG, PNG, GIF.</div>
            <input class="p-inputtext p-component" accept="image/*" name="images[]" id="images_service" type="file"
              @change="onFileSelectFile" multiple /><!--@change="onFileSelectLogo"-->
            <input class="input_tmp_validator" id="list_file">
            <div class="cus-text style_list_image">
              <div class="box-image" v-for="(item, index) in list_file" :key="index">
                <img class="style_img" :src="item.objectURL" />
                <div class="button-clear" @click="onFileClear(item, index)"><img
                    src="/assets/images/icon/cancel_black_24dp.png" /></div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right">Past the URL of a Youtube video </label>
          <div class="p-col">
            <InputText id="url_video" type="text" class="" v-model="obj_data.url_video"
              placeholder="https://www.youtube.com/..." />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="p-card-field">
          <label class="indam-car-for-sell p-col-fixed txt-right txt-required">Description </label>
          <div class="p-col">
            <input class="input_tmp_validator" id="validator_content_description">
            <CkditorCore :contentSet="obj_data.description" @newdata="handleDataCkditor($event, 0, 'description')">
            </CkditorCore>

          </div>
        </div>
      </div>




      <div class="col-6">
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.new" :binary="true" />
            <label class="p-col-fixed txt-right text">New</label>
          </div>
        </div>
        <div class="p-card-field div_check">
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.active" :binary="true" />
            <label class="p-col-fixed txt-right text">Active</label>
          </div>
        </div>


      </div>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
          <Button v-if="mode == 'edit'" :label="$constants.TEXT_BUTTON.EDIT" @click="saveData()"
            class="main-style-button" />
          <Button v-else :label="$constants.TEXT_BUTTON.ADD" @click="saveData()" class="main-style-button" />
        </template>
      </Toolbar>
      <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
        Are you sure you want to delete?
        <template #footer>
          <Button label="Delete" @click="deleteData()" icon="pi pi-check"
            class="p-button-danger  btn-confirm-delete-dialog" />
          <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
        </template>
      </Dialog>
    </div>
    <CustomCropper
      :key="keyCropper"
      v-if="showCropper"
      :image-src="imageSrc"
      @cropped-image="handleCroppedImage"
      @close="showCropper = false"
    />
  </form>
</template>
<script>
import CkditorCore from '../CkditorCore';
import moment from "moment-timezone";
import Calendar1 from '@/components/Calendar.vue';
export default {
  components: {
    CkditorCore,
    Calendar1,
  },
  props: {
    mode: String,
    model: Object,
    users: Array
  },
  data() {
    return {
      showCropper: false,
      keyCropper: 0,
      imageSrc: null,

      year: new Date(),

      key_type_id: 1,
      deleteId: null,
      showDeleteDialog: false,
      listDataType: [],
      obj_data: {
        discount: '%',
        address: '',
        discount_value: null,
        build: this.convertYearToDate(1970) // Khởi tạo giá trị mặc định
      },
      comFilename: 1,
      listPropertyType: [],
      listPropertyTypeAll: [],
      CarElectric: '',
      listUser: [],
      listUserAll: [],
      componentKey: 0,
      list_file: [],
      list_file_cover: [],
      list_id_file_delete: [],
      list_id_file_delete_cover: [],
      maxFileSize: 2097152 * 50,
      listCarSell: [
        {
          id: 1,
          name: "For sell",
        },
        {
          id: 2,
          name: "Sold out",
        },
        {
          id: 3,
          name: "Cancel",
        },
      ],
      listShowRoom: [],
      listVehicleCategory: [],
      listCarCommon_type1: [],
      listCarCommon_type2: [],
      listCarCommon_type3: [],
      list_type: [
        {
          id: 1,
          name: "New",
        },
        {
          id: 2,
          name: "Used",
        },
      ],
      list_file_cover_edit: [],
      detail_visit : null,
      code_sold_out: null,  
      listColor: [],
      colorInput: '',
      filteredColors: [],
    }
  },
  async mounted() {
    this.getLisShowroom();
    this.getLisVehicleCategory();
    this.getListCarCommon();
    this.getListColor();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.$commonFuction.convertJsonObject(this.model);
      console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvv', this.obj_data.build);
      console.log('fffffffffffffffffffff', this.obj_data);
      if (typeof this.obj_data.build === 'number') {
        this.obj_data.build = new Date(this.obj_data.build, 0, 1); 
      }
      if (this.obj_data.rental_order_sell_arr.length > 0) {
        const bookingBuyId = this.obj_data.rental_order_sell_arr
          .filter(item => item.rental_order.booking_status === "SOLD_BUY")
          .map(item => item.id);

        this.detail_visit = bookingBuyId.length > 0 ? bookingBuyId[0] : null;
      }
      // code_sold_out
      if (this.obj_data.rental_order_sell_arr.length > 0) {
        const codeSoldOut = this.obj_data.rental_order_sell_arr
          .filter(item => item.rental_order.booking_status === "SOLD_BUY")
          .map(item => item.rental_order.code);

        this.code_sold_out = codeSoldOut.length > 0 ? codeSoldOut[0] : null;
      }



      this.colorInput = this.obj_data?.obj_colour?.name ?? '';
      this.obj_data.rego_validation = this.formatDate(this.obj_data.rego_validation);
      if (this.obj_data.status === 'FOR_SELL') {
        this.obj_data.status = 1;
      } else if (this.obj_data.status === 'SOLD_OUT_SELL') {
        this.obj_data.status = 2;
      } else if (this.obj_data.status === 'CANCEL_SELL') {
        this.obj_data.status = 3;
      }
      this.obj_data.color_id = this.obj_data?.obj_colour?.name ?? null;
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit)) {
        var list_file_edit = this.model?.list_file_edit
        for (let i = 0; i < list_file_edit.length; i++) {
          var item_file = list_file_edit[i]
          var obj = { id: item_file.id, 'name': '', 'file': '', 'objectURL': item_file.url, type: 'old_edit' }//type:'old_edit' nếu gặp type này ko update avatar
          this.list_file_cover.push(obj)
        }
      }
      if (!this.$commonFuction.isEmpty(this.model?.list_file_edit_normal)) {
        var list_file_edit_normal = this.model?.list_file_edit_normal
        for (let i = 0; i < list_file_edit_normal.length; i++) {
          var item_file_normal = list_file_edit_normal[i]
          var obj_list_normal = { id: item_file_normal.id, 'name': '', 'file': '', 'objectURL': item_file_normal.url, type: 'old_edit' }//type:'old_edit' nếu gặp type này ko update avatar
          this.list_file.push(obj_list_normal)
        }
      }
      this.componentKey++;
    } else {

      this.obj_data = {
        active: true,
        new: true,
        type_of_price: '1',
        ordinal: 1,
        discount: '%',
      };
      this.componentKey++;
    }
  },
  watch: {
    'obj_data.build': function (newVal) {
      console.log("Updated build:", newVal); // Kiểm tra sự thay đổi của `build`
    }
  },


  methods: {
    handleCroppedImage(itemFile) {
      this.list_file_cover = [];
      this.list_file_cover.push(itemFile);
    },
    async getListColor() {
      const where_key = {
        deleted: { _eq: false },
      };
      const list = await this.$CoreService.getListColor(where_key);
      this.listColor = list.list;
      console.log('this.listColor', this.listColor);
    },
    filterColors() {
      const input = this.colorInput.toLowerCase();
      if (input) {
        this.filteredColors = this.listColor.filter(color =>
          color.name.toLowerCase().includes(input)
        );
      } else {
        this.filteredColors = []; // Clear suggestions when input is empty
      }
    },
    selectColor(color) {
      this.obj_data.color_id = color.id;
      this.colorInput = color.name;
      this.filteredColors = []; // Clear suggestions
    },
    convertYearToDate(year) {
      return new Date(year, 0, 1);
    },
    handleYearChange(value) {
    // Giữ obj_data.build dưới dạng Date để Calendar hoạt động chính xác
    if (value instanceof Date) {
      this.obj_data.build = new Date(value.getFullYear(), 0, 1); // Đặt lại ngày 1/1 của năm đã chọn
      console.log("Selected Year as Date:", this.obj_data.build); // Xác nhận giá trị
    }
  },

  // Hàm để lấy giá trị năm dưới dạng số nguyên khi lưu vào cơ sở dữ liệu
  getBuildYear() {
    return this.obj_data.build instanceof Date ? this.obj_data.build.getFullYear() : this.obj_data.build;
  },
    updateBuildValue() {
      // Cập nhật lại giá trị build khi mất focus
      if (this.obj_data.build && typeof this.obj_data.build === 'number') {
        this.obj_data.build = new Date(this.obj_data.build, 0, 1);
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = []
      for (let i = 0; i < this.listDataType.length; i++) {
        var item_data = this.listDataType[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataType = list_data;
    },

    formatDate(dateString) {
      if (!dateString) {
        return null;
        
      }
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
  
      return `${month}/${year}`;
    },
    handleDataCkditor: function (e, index, key) {
      var dataContent = e;

      if (Array.isArray(dataContent)) {
        dataContent = dataContent.join(' ');
      }
      console.log('dataContent', dataContent);
      if (key == 'description') {
        this.obj_data.description = dataContent;
      }
    },

    async onFileSelectFile(event) {
      const that = this;
      const files = event.target.files || event.dataTransfer.files;

      // Kiểm tra nếu tổng số ảnh đã chọn vượt quá 50
      if (this.list_file.length + files.length > 20) {
        alert("You can only upload a maximum of 20 images.");
        event.target.value = null;
        return;
      }

      if (files.length > 0) {
        const acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];

        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();

          // Kiểm tra định dạng ảnh
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }

          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }

        // Thêm ảnh mới vào danh sách
        const arrTemp = [];
        for (let file of files) {
          file.source = file;
          file.objectURL = window.URL.createObjectURL(file);
          arrTemp.push(file);
        }

        this.list_file = this.list_file.concat(arrTemp);
      }

      // Đặt lại giá trị input để có thể chọn lại cùng một file nếu cần
      event.target.value = null;
    },

    async onFileSelectFileCover(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 50) {
        alert("You can only upload a maximum of 50 files at a time");
      } else {
        // Kiểm tra định dạng ảnh
        let acceptTags = ['jpeg', 'jpg', 'gif', 'png', 'JPEG', 'JPG', 'PNG', 'GIF', 'svg', 'SVG'];
        for (let i = 0; i < files.length; i++) {
          const fileExtension = files[i].name.split('.').pop();
          if (!acceptTags.includes(fileExtension)) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            event.target.value = null;
            return;
          }
        }

        // Xóa ảnh cũ nếu có, sử dụng hàm onFileClearCover
        if (this.list_file_cover.length > 0) {
          this.onFileClearCover(this.list_file_cover[0], 0);
        }

        // Thêm ảnh mới
        let file = files[0];
        file.source = file;
        file.objectURL = window.URL.createObjectURL(file);
        this.list_file_cover.push(file);

        // this.showCropper = true;
        // this.imageSrc = URL.createObjectURL(file);
        // this.keyCropper++;

        // Xóa giá trị input để cho phép chọn lại cùng file nếu cần
        event.target.value = null;
      }

    },

    isImage(file) {
      return /^image\//.test(file.type);
    },

    async getLisShowroom() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getLisShowroom(where_key);
      this.listShowRoom = list.list;
    },
    async getLisVehicleCategory() {
      var where_key = {
        deleted: { _eq: false },
      }
      var list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.listVehicleCategory = list.list;
    },
    async getListCarCommon() {
      try {
        var where_key = {
          deleted: { _eq: false },
        };
        var list = await this.$CoreService.getListCarCommon(where_key);
        if (list && list.list && list.list.length > 0) {
          this.listCarCommon_type1 = [];
          this.listCarCommon_type2 = [];
          this.listCarCommon_type3 = [];
          list.list.forEach(item => {
            if (item.type === 1) {
              this.listCarCommon_type1.push(item);
            } else if (item.type === 2) {
              this.listCarCommon_type2.push(item);
            } else if (item.type === 3) {
              this.listCarCommon_type3.push(item);
            }
          });
          console.log('this.listCarCommon_type1', this.listCarCommon_type1);

          for (let index = 0; index < this.listCarCommon_type1.length; index++) {
            if (this.listCarCommon_type1[index].name === 'Electric') {
              this.CarElectric = this.listCarCommon_type1[index];
            }
          }

          console.log('this.CarElectric', this.CarElectric.name);


        }
      } catch (error) {
        console.error("Error fetching car common list:", error);
      }
    },

    async SearchPropertyType(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisShowroom(where_key);
        this.listPropertyType = list.list;
      } else {
        this.listPropertyType = this.listPropertyTypeAll
      }
    },
    async getListUser() {
      var where_key = {
        deleted: { _eq: false },
        role: { _eq: this.$constants.ROLE_ACCOUNT.OWNER },
      }
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser = list.list;
      this.listUserAll = list.list;
    },
    async SearchUser(search, loading) {
      console.log(loading);
      if (search !== '' && search !== null) {
        var where_key = {
          deleted: { _eq: false },
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
      } else {
        this.listUser = this.listUserAll
      }
    },


    backToList() {
      this.$emit('back');
    },
    async validateData() {
      this.validationErrors = {};
      const fieldsToValidate = [
        { id: "status", value: this.obj_data.status },
        { id: "code", value: this.obj_data.code },
        { id: "carname", value: this.obj_data.name },
        { id: "price_before", value: this.obj_data.price_before, minValue: -1 },
        { id: "price", value: this.obj_data.price, minValue: -1 },
        { id: "showroom", value: this.obj_data.showroom_id },
        { id: "make", value: this.obj_data.make_vehicle_category_id },
        { id: "model", value: this.obj_data.model },
        { id: "build", value: this.obj_data.build },
        { id: "new_used", value: this.obj_data.type },
        { id: "color_id", value: this.obj_data.color_id ?? this.colorInput},
        { id: "odometer", value: this.obj_data.odometer, minValue: -1 },
        { id: "fuel_type_id", value: this.obj_data.fuel_type_id },
        { id: "transmission_id", value: this.obj_data.transmission_id },
        { id: "finance_id", value: this.obj_data.finance_id },
        // { id: "rego_validation", value: this.obj_data.rego_validation },
        { id: "validator_content_description", value: this.obj_data.description },
      ];
      let isFormInvalid = false;
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);
        if (inputElement && (inputElement.tagName === "INPUT" || inputElement.tagName === "TEXTAREA" || inputElement.tagName === "SELECT")) {
          if (this.$commonFuction.isEmptyObject(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else if (field.minValue !== undefined && field.value <= field.minValue) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
            isFormInvalid = true;
          }
          else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let list_file_cover = document.getElementById("list_file_cover");
      if (this.list_file_cover.length === 0) {
        list_file_cover.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file_cover.reportValidity();
        isFormInvalid = true;
      } else {
        list_file_cover.setCustomValidity("");
      }
      let list_file = document.getElementById("list_file");
      if (this.list_file.length === 0) {
        list_file.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
        list_file.reportValidity();
        isFormInvalid = true;
      } else {
        list_file.setCustomValidity("");
      }
      if(isFormInvalid == false){
        //kiểm tra price_per_unit_before < price_per_unit
        let price = document.getElementById("price");
        if(this.obj_data.price > this.obj_data.price_before) {
          price.setCustomValidity('Price before discount must be greater than or equal to Price after discount.');
          isFormInvalid = true;
        }else{
          price.setCustomValidity("");
        }
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity() || isFormInvalid) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }

      var params = { ...this.obj_data };

      // Chuyển đổi rego_validation thành YYYY-MM-DD
      if (!params.rego_validation) {
        // Nếu rego_validation không tồn tại, gán giá trị null
        params.rego_validation = null;
      } else if (params.rego_validation instanceof Date) {
        // Nếu rego_validation là đối tượng Date, định dạng lại
        params.rego_validation = moment(params.rego_validation).format('YYYY-MM-DD');
      } else if (typeof params.rego_validation === 'string') {
        // Nếu rego_validation là chuỗi "MM/YYYY", thêm ngày và chuyển thành định dạng YYYY-MM-DD
        const regoDate = moment(`${params.rego_validation}-01`, 'MM/YYYY-DD');
        params.rego_validation = regoDate.isValid() ? regoDate.format('YYYY-MM-DD') : null;
      }

      // Chuyển đổi build thành số nguyên nếu cần
      params.build = this.getBuildYear();

      // Các thuộc tính khác
      params.list_file_cover = this.list_file_cover;
      params.list_file_cover_edit = this.list_file_cover_edit;
      params.list_file = this.list_file;
      params.list_id_file_delete = this.list_id_file_delete;
      params.list_id_file_delete_cover = this.list_id_file_delete_cover;
      params.color_id = this.colorInput;
      console.log('1111111111111111111111111111111111111111111', params);

      this.$emit('save', params);
    }
    ,

    onFileClear(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete.push(item);
      }
      this.list_file.splice(index, 1);
    },
    onFileClearCover(item, index) {
      var type = item?.type ?? null
      if (type == 'old_edit') {
        this.list_id_file_delete_cover.push(item);
      }
      this.list_file_cover.splice(index, 1);
    },
  },
}
</script>
<style lang="scss">
.p-formgrid {
  padding-top: 20px;
}

.main-style-button {
  background-color: #FFDF01 !important;
}

.opacity-text-file {
  opacity: 0.5;
}

.calendar-css-margin1 {
  padding-right: 0px !important;
}

.calendar-css-margin2 {
  padding-left: 0px !important;
}

.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;
}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}


@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}


.p-col-fixed {
  padding: 0px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}
.p-button-outlined .p-button-label {
    color: #000000 !important;
}
.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}

.style_title_group_car_infomation {
  padding: 10px 0 0 0 !important;
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #0c0101;
  text-transform: uppercase;
}

.indam-car-for-sell {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}

// suggest color
.color-suggestion-component {
  position: relative;
}

.color-suggestion-component .color-label {
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
  display: inline-block;
}

.color-suggestion-component .color-input-wrapper {
  position: relative;
}

.color-suggestion-component .color-input-wrapper input {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
  transition: border-color 0.2s ease-in-out;
}

.color-suggestion-component .color-input-wrapper input:focus {
  border-color: #007bff;
  outline: none;
}

.color-suggestion-component .suggestion-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  padding: 0;
  margin: 5px 0 0;
  list-style: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.color-suggestion-component .suggestion-list li {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  font-size: 14px;
  color: #333;
}

.color-suggestion-component .suggestion-list li:hover {
  background-color: #f5f5f5;
}

.color-suggestion-component .suggestion-list li:active {
  background-color: #e0e0e0;
}




// 



.p-inputgroup .p-inputtext, .p-fluid .p-inputgroup .p-inputtext, .p-inputgroup .p-inputwrapper, .p-fluid .p-inputgroup .p-input {
    flex: 1 1 auto;
    width: 1%;
    margin-top: 7px;
    height: 38px;
}

.p-inputgroup > .p-component + .p-inputgroup-addon, .p-inputgroup > .p-inputwrapper > .p-inputtext + .p-inputgroup-addon, .p-inputgroup > .p-float-label > .p-component + .p-inputgroup-addon {
    height: 38px;
    border-left: 0 none;
    margin-top: 7px;
    width: 20px;
}

// 
.class-left1111 { 
  width: 98.5%;
  margin-right: -15px;
}
.asdasdfasf { 
  margin-right: -11px;
}
.css-tieu-de-big { 
  padding-top: 20px !important;
  font-size: 18px;
}

.link-detail-visit-a{
  color: #007ad9;
  text-decoration: underline;
  cursor: pointer;
}



.disabled-input {
  background-color: #f5f5f5; /* Light grey background */
  color: #007ad9; /* Grey text color */
  cursor: pointer; /* Pointer cursor to show it's clickable */
  border-color: #ccc; /* Light grey border to match disabled style */
}

.width-odo111 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
</style>
